var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer content text-center",class:{xuanfuBox:_vm.xuanfuBool}},[(!_vm.xuanfuBool)?_c('span',[_c('img',{attrs:{"src":"/static/images/gongan.png"}}),_vm._v("皖公网安备11011278044298号、雪帝数字音频有限公司、皖ICP备2056707014号-1\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01943f98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = null
// module chunks = 